var NotificationStyle;
(function(NotificationStyle2) {
  NotificationStyle2["INFO"] = "info";
  NotificationStyle2["MESSAGE"] = "message";
  NotificationStyle2["ALERT"] = "alert";
  NotificationStyle2["ERROR"] = "error";
  NotificationStyle2["SUCCESS"] = "success";
  NotificationStyle2["TOP_NAV_COOKIE"] = "cookie";
})(NotificationStyle || (NotificationStyle = {}));
var NotificationDelay;
(function(NotificationDelay2) {
  NotificationDelay2[NotificationDelay2["SHORT"] = 2500] = "SHORT";
  NotificationDelay2[NotificationDelay2["DEFAULT"] = 5e3] = "DEFAULT";
  NotificationDelay2[NotificationDelay2["LONG"] = 1e4] = "LONG";
  NotificationDelay2[NotificationDelay2["PERMANENT"] = 10001] = "PERMANENT";
})(NotificationDelay || (NotificationDelay = {}));

export { NotificationDelay, NotificationStyle };
